
import { useState } from "react";
import { Settings, EllipsisVertical } from "lucide-react"; 		// ← eventueel installeren: npm install lucide-react



export default function ProjectCard( { id, imageSrc, title, onClick, menuActions } ) {

	const [hover, setHover] = useState(false);


	/***
	
		Settings button
	
	*/
	const [menuOpen, setMenuOpen] = useState(false);

	const [settingsHover, setSettingsHover] = useState(false);


	const handleSettingsClick = (e) => {

		e.stopPropagation();

		setMenuOpen((prev) => !prev);
	};



	const handleOptionClick = (action) => {

		setMenuOpen(false);
		
		console.log(`Je koos: ${action}`); // vervang dit met je eigen logica

		switch( action ){
		
			case "delete":
				menuActions.delete( id );
				break;
			
			case "rename":
				menuActions.rename( id, title );
				break;

			default:

				break;
		}
	};






	return (
		<>
		
			<div 
				className				= {`project-card ${menuOpen ? "menu-open" : ""}`}
				
				onMouseEnter			={() => setHover(true)}

				onMouseLeave			={() => {
											setHover(false);
											setMenuOpen(false); // menu sluiten als je van de kaart afgaat
										}}
				
				onClick					= { onClick }
			>
				{/* ⚙️ Settings-knop (alleen zichtbaar bij hover) */}
				{hover && (
					<button
						className			= "project-card-settings-btn"
						onClick				= {handleSettingsClick}
						onMouseEnter		= {() => setSettingsHover(true)}
						onMouseLeave		= {() => setSettingsHover(false)}
					>

						<Settings 
							size			= { 28 } 
							color			= "#002244" 
							className		= {`project-card-settings-icon ${settingsHover ? "rotated" : ""}`}
						/>

					</button>
				)}

				 {/* 📋 Settings-menu */}
				{menuOpen && (
					<div
						className			= "project-card-menu"
						onClick				= {(e) => e.stopPropagation()}
					>
						
						{
							[
								// "edit", 
								"rename",
								// "duplicate", 
								"delete"
							]
							.map( ( option ) => (

								<div
									key				= { option }
									className		= "project-card-menu-item"
									onClick			= { () => handleOptionClick( option ) }
								>
									{option}
								</div>
							))
						}
					</div>
				)}
			

				<div className="board-preview">
					<div className="whiteboard-icon"></div>
				</div>
				
				<div 
					// className="bottom-centered"
					className			= "project-card-title"
				>
					{ title }
				</div>
			</div>
		</>
	)
}
